import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
// ui
import Drawer from "@mui/material/Drawer";
// store
import { StoreContext } from "../../../../store/StoreProvider";

//
import { getSidebarContent } from "./utils";
// config
import { drawerWidth } from "../../config";
import useModulePublic from "../../../hooks/useModulePublic";
import Act from "../../../../store/actions";
import EditDialog from "./components/EditDialog";

//
const Sidebar = () => {
  // route,intl
  const intl = useIntl();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { sidebar, adjust } = sna;
  //
  // hooks
  const { handlePublic } = useModulePublic();

  const drawerInner = getSidebarContent(sidebar.contentName);

  return (
    <>
      <Drawer
        variant="persistent"
        anchor="left"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper.MuiDrawer-paperAnchorLeft": {
            position: "absolute",
            top: "64px",
            left: "72px",
            height: "calc(100% - 64px)",
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#121212",
            "&>.MuiBox-root": {
              height: "calc(100%-64px)",
              paddingX: "24px",
              paddingY: "24px",
            },
          },
        }}
        open={sidebar.open}
      >
        {drawerInner}
      </Drawer>
      <EditDialog />
    </>
  );
};

export default Sidebar;
